"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _777Icon = createIcon({
  displayName: "_777Icon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m29.216 25.697481h46.130047v46.130047h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m95.003593 25.696436h46.130047v46.132145h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m29.216 92.719498h46.130047v46.131096h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m95.003593 92.719498h46.130047v46.132145h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m161.00478 25.898508h46.126907v46.131096h-46.126907z"
        fill="currentColor"
      />
      <path
        d="m226.78923 25.899555h46.131096v46.131096h-46.131096z"
        fill="currentColor"
      />
      <path
        d="m161.00478 92.922615h46.126907v46.129002h-46.126907z"
        fill="currentColor"
      />
      <path
        d="m226.78923 92.922615h46.131096v46.131096h-46.131096z"
        fill="currentColor"
      />
      <path
        d="m29.216 159.94357h46.130047v46.13319h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m95.003593 159.94357h46.130047v46.13319h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m29.216 226.96454h46.130047v46.132145h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m95.003593 226.96873h46.130047v46.127953h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m161.00478 159.94357h46.126907v46.131096h-46.126907z"
        fill="currentColor"
      />
      <path
        d="m226.78923 159.94357h46.131096v46.13319h-46.131096z"
        fill="currentColor"
      />
      <path
        d="m161.00478 226.96454h46.126907v46.132145h-46.126907z"
        fill="currentColor"
      />
      <path
        d="m226.78923 226.96873h46.131096v46.127953h-46.131096z"
        fill="currentColor"
      />
      <path
        d="m292.57892 25.899555h46.130047v46.131096h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m292.57892 92.922615h46.130047v46.131096h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m292.57892 159.94357h46.130047v46.13319h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m292.57892 226.96873h46.130047v46.127953h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m29.321747 293.99179h46.130047v46.127953h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m95.109337 293.99179h46.130047v46.127953h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m161.11157 293.99179h46.127953v46.127953h-46.127953z"
        fill="currentColor"
      />
      <path
        d="m226.89497 293.99179h46.134235v46.127953h-46.134235z"
        fill="currentColor"
      />
      <path
        d="m292.68463 293.99179h46.132145v46.127953h-46.132145z"
        fill="currentColor"
      />
      <path
        d="m358.47015 25.897463h46.130047v46.131096h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m358.47015 92.920517h46.130047v46.131096h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m358.47015 159.94254h46.130047v46.132145h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m358.47015 226.96558h46.130047v46.129002h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m424.25775 25.897463h46.130047v46.131096h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m424.25775 92.920517h46.130047v46.131096h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m424.25775 159.94254h46.130047v46.132145h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m424.25775 226.96558h46.130047v46.129002h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m358.57697 293.98972h46.132145v46.127953h-46.132145z"
        fill="currentColor"
      />
      <path
        d="m424.36453 293.98972h46.130047v46.127953h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m29.321747 361.01273h46.132145v46.132145h-46.132145z"
        fill="currentColor"
      />
      <path
        d="m95.11039 361.01486h46.130047v46.130047h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m161.11157 361.01273h46.127953v46.132145h-46.127953z"
        fill="currentColor"
      />
      <path
        d="m226.89706 361.01486h46.130047v46.130047h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m292.68463 361.01486h46.127953v46.130047h-46.127953z"
        fill="currentColor"
      />
      <path
        d="m29.427494 428.03894h46.132145v46.130047h-46.132145z"
        fill="currentColor"
      />
      <path
        d="m95.217178 428.03894h46.130047v46.130047h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m161.21837 428.03894h46.127953v46.130047h-46.127953z"
        fill="currentColor"
      />
      <path
        d="m227.00281 428.03894h46.13319v46.130047h-46.13319z"
        fill="currentColor"
      />
      <path
        d="m292.78934 428.03894h46.132145v46.130047h-46.132145z"
        fill="currentColor"
      />
      <path
        d="m358.57697 361.01273h46.130047v46.130047h-46.130047z"
        fill="currentColor"
      />
      <path
        d="m424.36453 361.01273h46.127953v46.130047h-46.127953z"
        fill="currentColor"
      />
      <path
        d="m358.68375 428.03687h46.132145v46.130047h-46.132145z"
        fill="currentColor"
      />
      <path
        d="m424.46924 428.03687h46.132145v46.130047h-46.132145z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _777Icon;
